var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#50AF95"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2509 17.1962C18.1621 17.2028 17.7029 17.23 16.6787 17.23C15.8641 17.23 15.2857 17.2057 15.0828 17.1962C11.9347 17.0589 9.58485 16.5157 9.58485 15.8653C9.58485 15.2149 11.9347 14.6724 15.0828 14.533V16.6552C15.2887 16.6699 15.8782 16.7044 16.6928 16.7044C17.6703 16.7044 18.1599 16.664 18.248 16.6559V14.5344C21.3895 14.6732 23.7341 15.2164 23.7341 15.8653C23.7341 16.5142 21.3902 17.0575 18.248 17.1955L18.2509 17.1962ZM18.2509 14.315V12.4159H22.6351V9.51996H10.6987V12.4159H15.0821V14.3142C11.5192 14.4764 8.83984 15.176 8.83984 16.0143C8.83984 16.8527 11.5192 17.5515 15.0821 17.7145V23.8H18.2502V17.7123C21.8049 17.55 24.4798 16.8512 24.4798 16.0136C24.4798 15.176 21.8071 14.4772 18.2502 14.3142L18.2509 14.315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtIcon);
export default __webpack_public_path__ + "static/media/usdt-icon.3c9cc7b3ea6caca55ed0d6cbfab9cad0.svg";
export { ForwardRef as ReactComponent };